import React, { useEffect } from 'react'

export const EMPTY_TAG = '!EMPTY!'
export const FUNCTION_SEPARATOR_TAG = '_|_'

function templateApplyValues(template, valuesObj, valuesKeys) {
  return Object.keys(valuesKeys).reduce((str, k) => str.replace(k, valuesKeys[k](valuesObj)), template)
}

const templateApplyFunctions = (template, valuesObj, valuesKeys, functionKeys) => {
  const clonedTemplate = template.slice()

  const stringValue = Object.keys(functionKeys).reduce((str, k) => {
    const myRegexp = new RegExp(`${k}(.*?)_${k}_`)
    let match = myRegexp.exec(str)
    while (match != null) {
      const conditionalStringsMatch = match[1];
      const options = conditionalStringsMatch.split(FUNCTION_SEPARATOR_TAG)
      const keyConditionValue = functionKeys[k](valuesObj)
      str = str.replace(myRegexp, keyConditionValue ?
        templateApplyValues(options[0], valuesObj, valuesKeys)
        : templateApplyValues(options[1], valuesObj, valuesKeys)
      )
      match = myRegexp.exec(str)
    }
    return str
  }, clonedTemplate)

  return stringValue.split('\n').filter(line => (line ? line.trim() : line) !== EMPTY_TAG).join('\n')
};

const templateApplyLocalizations = (template, localizations) => {
  const templateAfterText = replaceTexts(template, localizations)
  const templateAfterMedia = replaceMedia(templateAfterText, localizations)
  return templateAfterMedia.replaceAll('\\n', '<br/>')
}

function replaceTexts(template, localizations) {
  const texts = localizations.filter(l => l.type === 'TEXT')
  const regex = new RegExp('[[text:[a-zA-Z0-9_\-]+]]', 'g')
  let str = template.slice()
  let match = regex.exec(str)
  while (match != null) {
    const found = match[0]
    const key = found.replaceAll('[', '').replaceAll(']', '').replaceAll('text:', '')
    str = str.replaceAll(found, texts.find(t => t.key === key)?.value || found)
    match = regex.exec(str)
  }
  return str
}

function replaceMedia(template, localizations) {
  const texts = localizations.filter(l => l.type === 'MEDIA')
  const regex = new RegExp('[[media:[a-zA-Z0-9_\-]+]]', 'g')
  let str = template.slice()
  let match = regex.exec(str)
  while (match != null) {
    const found = match[0]
    const key = found.replaceAll('[', '').replaceAll(']', '').replaceAll('media:', '')
    str = str.replace(found, texts.find(t => t.key === key)?.value)
    match = regex.exec(str)
  }
  return str
}

export function buildTemplateFactory(templateString, valuesObj, localizations, functionKeys, valuesKeys) {
  const clonedTemplate = templateString.slice();
  const templateAfterFunctions = templateApplyFunctions(clonedTemplate, valuesObj, valuesKeys, functionKeys);
  const templateAfterValues = templateApplyValues(templateAfterFunctions, valuesObj, valuesKeys);
  return templateApplyLocalizations(templateAfterValues, localizations)
}

export function DynamicContent({ content, onLoad = () => { }, onClick }) {
  useEffect(() => {
    if (content) {
      onLoad()
    }
  }, [content])

  return (
    <div onClick={onClick} dangerouslySetInnerHTML={{ __html: content }} />
  )
}
